import React from 'react';
import { Link } from 'react-router-dom';
import { AiOutlineTwitter } from 'react-icons/ai';

class Footer extends React.Component {
  render() {
    return (
      <>
        <footer className="wrapper r-wrapper">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="25.7"
            className="main-footer__wave"
            data-v-22168a6a=""
          >
            <path d="M1440 15.3s-64.6 9.5-156.4 10.2c-188.7 1.6-276.8-20.8-419.9-20.1s-202.9 14-290.8 13.4c-94.4-.7-194-13.3-331.9-13.3-137.3 0-156.8 8.2-241 9.8V0h1440v15.3z"></path>
          </svg>
          <div className="footer-cont">
            <div className="footer-details">
              <Link to="/" className="logo">
                Learnist
              </Link>
              {['Sessions', 'about'].map((menuitem, idx) => (
                <li key={idx}>
                  <a href={`#${menuitem}`} className="footer-nav-item">
                    {menuitem}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href=" https://discord.gg/RC6M5Us"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-nav-item"
                  style={{ color: '#00ffa4' }}
                >
                  JOIN
                </a>
              </li>
            </div>
            <div className="footer-social-details">
              <a
                className="social-logo"
                href="https://twitter.com/thelearnist"
                target="_blank"
                rel="noopener noreferrer"
              >
                <AiOutlineTwitter />
              </a>
              <p className="footer-trademark">© 2020 Learnist</p>
            </div>
          </div>
        </footer>
      </>
    );
  }
}

export default Footer;
